import React, { FormEvent } from 'react'
import {
  Button, Dialog, DialogContent, DialogTitle, TextField, Typography,
} from '@mui/material'
import { GoogleLogo } from 'icons'
// @ts-ignore -- JS style module is not typed yet.
import useStyles from './StatsAuth.style'

interface Props {
  username: string,
  password: string,
  setUsername: (value: string) => void,
  setPassword: (value: string) => void,
  onLoginHandler: (event: FormEvent<HTMLFormElement>) => void,
  redirectUrl: string,
}

const StatsAuth: React.FC<Props> = (props) => {
  const {
    username, password, setUsername, setPassword, onLoginHandler, redirectUrl,
  } = props
  const { classes } = useStyles()

  const googleSignInUrl = (host = window.location.hostname) => {
    const params = new URLSearchParams({
      source: 'statistic',
      path_url: redirectUrl,
    })
    const query = params.toString()

    if (host === 'localhost') {
      return `http://${host}:3000/auth/google_oauth2?${query}`
    }
    return `https://${host.replace('web', 'adm')}/auth/google_oauth2?${query}`
  }

  const generatedGoogleSignInUrl = googleSignInUrl()

  const submitGoogleSignIn = () => {
    const form = document.createElement('form')
    form.method = 'post'
    form.action = generatedGoogleSignInUrl

    document.body.appendChild(form)
    form.submit()
  }

  return (
    <Dialog open>
      <DialogTitle className={classes.titleContainer}>
        <Typography className={classes.title}>Sign in with your admin panel credentials</Typography>
      </DialogTitle>
      <DialogContent>
        <form
          className={classes.formContainer}
          onSubmit={onLoginHandler}
        >
          <TextField
            variant="standard"
            label="Email"
            type="email"
            value={username}
            onChange={(evt) => setUsername(evt.target.value)}
            className={classes.input}
          />
          <TextField
            variant="standard"
            label="Password"
            type="password"
            value={password}
            onChange={(evt) => setPassword(evt.target.value)}
            className={classes.input}
          />
          <Button
            color="primary"
            type="submit"
            variant="contained"
            className={classes.btn}
            disabled={!username && !password}
          >
            Sign In
          </Button>
        </form>
        <div className={classes.googleButtonContainer}>
          <Button
            color="primary"
            variant="contained"
            className={classes.googleButton}
            type="button"
            onClick={submitGoogleSignIn}
          >
            <GoogleLogo />
            {I18n.t('stats.sign_in_google')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default StatsAuth
